import { Component, Vue } from 'vue-property-decorator'

import { dadata } from '@/store/modules/dadata'
import { registration } from '@/store/modules/registration/index'

interface LocationData {
  latitude: number
  longitude: number
  accuracy: number
}

@Component
export class Geolocation extends Vue {
  dadataModule = dadata.context(this.$store)
  registrationModule = registration.context(this.$store)

  getUserLocation(): Promise<LocationData> {
    return new Promise((resolve, reject) => {
      if (!navigator.geolocation) {
        reject(new Error('Геолокация не поддерживается'))
        return
      }

      navigator.geolocation.getCurrentPosition(
        position => {
          const { latitude, longitude, accuracy } = position.coords
          resolve({ latitude, longitude, accuracy })
        },
        error => {
          let errorMessage
          switch (error.code) {
            case error.PERMISSION_DENIED:
              errorMessage = 'Пользователь отказал в доступе к геолокации'
              break
            case error.POSITION_UNAVAILABLE:
              errorMessage = 'Информация о местоположении недоступна'
              break
            case error.TIMEOUT:
              errorMessage = 'Время ожидания истекло'
              break
            default:
              errorMessage = 'Неизвестная ошибка'
          }
          reject(new Error(errorMessage))
        },
        {
          enableHighAccuracy: true,
          timeout: 10000,
          maximumAge: 3000000,
        }
      )
    })
  }

  async mounted() {
    try {
      const { latitude, longitude, accuracy } = await this.getUserLocation()
      const oktmoList = await this.dadataModule.actions.getOktmoListByGeo({
        lat: latitude,
        lon: longitude,
        radius_meters: accuracy,
      })
      if (oktmoList.length) {
        const oktmo = oktmoList[0].slice(0, 8)
        const districtsList = await this.registrationModule.actions.getDistrictsList(oktmo)
        this.dadataModule.mutations.setDistrictCodeByGeo(districtsList[0]?.code)
      }
    } catch (error) {
      console.error('Ошибка получения координат:', (error as Error).message)
    }
  }
}
